import React, { useState } from "react";
import Button from "../../../../reusable-components/buttons/Button";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { linkTextPrimary } from "../../../../theme/lightTheme";

import { COLOR_CONFIG_URL } from "../../../../api/api_routing_urls";
import axios from "../../../../api/axios";
import DeleteModal from "../../../../reusable-components/modals/DeleteModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import { linkTextDanger } from "../../../../theme/lightTheme";

export default function ColorList({
  colorList,
  getColorList,
  setEditColorDetails,
  setShowAddForm,
}) {
  const onClickEdit = (color) => {
    setEditColorDetails(color);
    setShowAddForm(true);
  };

  const [showDelete, setShowDelete] = useState(false);
  const [colorDeleteId, setColorDeleteId] = useState(null);

  const onClickDelete = async () => {
    // console.log("Received ID to delete: ", colorDeleteId);
    try {
      let response = "";
      if (colorDeleteId) {
        response = await axios.post(`${COLOR_CONFIG_URL}/delete`, {
          color_id: colorDeleteId,
        });
        setShowDelete(false);
      }

      if (response.status === 200) {
        showToast("Color details has been deleted successfully.", "success");
        getColorList();
      } else {
        showToast("Color details deletion failed.", "error");
      }
    } catch (error) {
      console.log("Delete Module Error", error);
    } finally {
      setColorDeleteId(null);
    }
  };

  return (
    <TableWrapper>
      <thead className="bg-white text-sm">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Sl No.
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Color Name
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Color Code
          </th>
          <th
            scope="col"
            className="pl-6 pr-9 py-3 text-right font-medium text-gray-900 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-100 text-gray-600">
        {colorList?.length > 0 &&
          colorList?.map((color, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {index+1}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {color.color_name}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {color.color_code}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex justify-end">
                  <Button
                    onClick={() => onClickEdit(color)}
                    aria-label="Edit Color Details"
                    className={linkTextPrimary}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      setColorDeleteId(color?.color_id || null);
                      setShowDelete(true);
                    }}
                    aria-label="Delete Color Details"
                    className={linkTextDanger}
                  >
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>

      <>
        <DeleteModal
          open={showDelete}
          setOpen={setShowDelete}
          message={"This entry will be deleted. Are you sure?"}
          onDelete={onClickDelete}
        />
      </>
    </TableWrapper>
  );
}
